import {ProFormInstance} from "@ant-design/pro-form";
import {Form,} from "antd";
import React, {useEffect, useRef} from "react";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {WdiInput, WdiModalAppProps} from "@/components/WdiControls";
import {ResponseStatus} from "@/utils/request";
import {
  DateCustomizeInputValue,
  DateCustomizeType, RebateStandardDateCustomizeInput
} from "@/pages/policy/ProductPolicyApply/components/rebateStandardDateCustomizeInput";
import {ProductCustomizeInputValue, RebateStandardProductCustomizeInput} from "./rebateStandardProductCustomizeInput";

export type RebateStandardCustomizeModalValueProps = {
  productPolicyParameter?: API.ProductPolicyParameter
  dateCustomizeInputValue?: DateCustomizeInputValue
  productCustomizeInputValue?: ProductCustomizeInputValue
}

type RebateStandardCustomizeModalProps = {
  value?: RebateStandardCustomizeModalValueProps
} & WdiModalAppProps

export const RebateStandardCustomizeModalApp: React.FC<RebateStandardCustomizeModalProps> = (props) => {

  const formRef = useRef<ProFormInstance>();
  useEffect(() => {
    formRef.current?.setFieldsValue({
      productPolicyParameterId: props.value?.productPolicyParameter?.productPolicyParameterId,
      productPolicyParameterName: props.value?.productPolicyParameter?.parameterName,
      dateCustomizeInputValue: props.value?.dateCustomizeInputValue,
      productCustomizeInputValue: props.value?.productCustomizeInputValue,
    })
  }, [props.value]);

  return (
    <WdiModalForm
      formRef={formRef}
      labelCol={{span: 4}}
      wrapperCol={{span: 18}}
      labelAlign='left'
      layout="horizontal"
      title={'自定义参数条件'}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
        destroyOnClose: true,
        maskClosable: false,
        centered: true
      }}
      width={600}
      overflowY={"hidden"}
      bodyHeight={500}
      onFinish={async (value: any) => {
        props.onSave?.({
          code: ResponseStatus.SUCCESS, data: {
            productPolicyParameter: props.value?.productPolicyParameter,
            dateCustomizeInputValue: value?.dateCustomizeInputValue,
            productCustomizeInputValue: value?.productCustomizeInputValue
          }
        });
      }}


    >
      <Form.Item
        label={'参数ID'}
        hidden={true}
        name={'productPolicyParameterId'}>
        <WdiInput readOnly/>
      </Form.Item>

      <Form.Item
        rules={[{
          required: true,
          message: '参数名称不能为空'
        }]}
        label={'参数名称'}
        name={'productPolicyParameterName'}>
        <WdiInput readOnly/>
      </Form.Item>

      {props.value?.productPolicyParameter?.isProductSelectable &&
        <Form.Item
          rules={[{
            required: true,
            message: '产品范围不能为空'
          }]}
          label={'产品范围'}
          name={'productCustomizeInputValue'}
        >
          <RebateStandardProductCustomizeInput/>
        </Form.Item>
      }


      <Form.Item
        rules={[{
          required: true,
          validator: async (_rule, value: DateCustomizeInputValue) => {
            if (!value?.typeId) {
              return Promise.reject('日期范围不能为空')
            }
            const dynamicDateRangeField = ['startDay', 'endDay'];
            const dynamicDateRange: any = value?.dynamicDateValue;
            if (DateCustomizeType.DYNAMIC == value.typeId && dynamicDateRangeField.some(item => !dynamicDateRange?.[item])) {
              return Promise.reject('请选择动态日期')
            }
            return Promise.resolve();
          }
        }]}
        label={'日期范围'}
        name={'dateCustomizeInputValue'}
      >
        <RebateStandardDateCustomizeInput/>
      </Form.Item>


    </WdiModalForm>
  )
}

